import { IconSearch } from '@tabler/icons-react'
import { useNavigate } from 'react-router-dom'
import styles from '../../styles/admin/Main.module.scss'
import BaseButton from '../common/SaveButton'
import SearchInput from '../common/SearchInput'
import Dropdown from '../common/Select'
import { LectureQuestionData } from '../../types/lectures'

interface HeaderSectionProps {
  selectedLevel: string
  onLevelChange: (value: string) => void
  data: LectureQuestionData[]
  currentPage: number
  labelSearch?: string
  onLabelSearch?: (value: string) => void
}
const HeaderSection = ({
  selectedLevel,
  onLevelChange,
  data,
  currentPage,
  labelSearch = '',
  onLabelSearch,
}: HeaderSectionProps) => {
  const navigate = useNavigate()



  const handleVideoCreateClick = () => {

    navigate('/lectures/lecture/create', {
      state: {fromPage: currentPage, level:data[0].LEVEL },
    })
  }

  const handleQuestionCreateClick = () => {

    navigate('/lectures/quiz/create', {
      state: {fromPage: currentPage, level:data[0].LEVEL },
    })
  }

  return (
    <div className={styles.headerSection}>
      <div className={styles.leftSection}>
        <p>Class List</p>
        <Dropdown value={selectedLevel} onChange={onLevelChange} />
        {onLabelSearch && (
          <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
            <IconSearch
              size={14}
              style={{ position: 'absolute', left: '8px', color: '#9ca3af', pointerEvents: 'none' }}
            />
            <input
              value={labelSearch}
              onChange={(e) => onLabelSearch(e.target.value)}
              placeholder="11111 or 1-1-1-1-1"
              style={{
                height: '36px',
                paddingLeft: '28px',
                paddingRight: '10px',
                border: '1px solid #ced4da',
                borderRadius: '6px',
                fontSize: '13px',
                width: '160px',
                outline: 'none',
              }}
            />
          </div>
        )}
      </div>
      <div className={styles.rightSection}>
        <BaseButton
          className={styles.createButton}
          onClick={handleVideoCreateClick}
        >
          Video
        </BaseButton>
        <BaseButton
          className={styles.createButton}
          onClick={handleQuestionCreateClick}
        >
          Question
        </BaseButton>
      </div>
    </div>
  )
}

export default HeaderSection
